import { useState } from "react";
import { Button } from "@/components/ui/button";
import QuoteModal from "@/components/QuoteModal";

/**
 * The home page's closing call to action — "Ready to Begin Your Healing
 * Journey?" over the treatment-room photo, with Get a Free Quote and WhatsApp
 * Us — for the pages that end without one. It opens its own quote form, so a
 * page only has to place it above its footer.
 */
export default function HealingJourneyCta() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  return (
    <>
      <section className="relative py-12 md:py-14 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="/healing-journey-bg.webp" alt="Holistic Healing Journey" loading="lazy" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="container mx-auto px-4 text-center relative z-10 max-w-4xl">
          <h2 className="text-3xl md:text-6xl font-bold text-white mb-4 leading-tight">
            Ready to Begin Your <br className="hidden md:block" />
            Healing Journey?
          </h2>
          <p className="text-base md:text-xl text-white/90 mb-10 font-medium leading-relaxed max-w-2xl mx-auto">
            Contact us today for a free consultation. Our doctors will guide you towards the perfect treatment program.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              onClick={() => setQuoteOpen(true)}
              size="lg"
              className="w-72 max-w-full bg-[#C24E00] hover:bg-[#A84300] text-white font-bold text-lg py-6 h-auto px-10 rounded-xl shadow-xl transition-all"
            >
              Get a Free Quote
            </Button>
            {/* a link, so the page's own message is filled in when it is opened (lib/whatsappMessage) */}
            <Button
              asChild
              variant="secondary"
              size="lg"
              className="w-72 max-w-full bg-white hover:bg-[#EEF4F5] text-[#2C4E5A] font-bold text-lg py-6 h-auto px-10 rounded-xl shadow-xl transition-all"
            >
              <a href="https://wa.me/919156115572" target="_blank" rel="noopener noreferrer">
                WhatsApp Us
              </a>
            </Button>
          </div>
        </div>
      </section>
      <QuoteModal open={quoteOpen} onOpenChange={setQuoteOpen} />
    </>
  );
}
